import React, { useState } from 'react';
import Modal from 'react-modal';
import axiosInstance from '../utils/axiosInstance';
import { API_URL } from '../utils/runtimeConfig';
import './css/AddNationModal.css';

const apiUrl = API_URL

const AddNationModal = ({ isOpen, onRequestClose, onNationAdded }) => {
    const axios = axiosInstance
    const [number, setName] = useState('');

    const handleSave = async () => {
        try {
            const newNation = {
                number
            };
            await axios.post(`${apiUrl}/nations`, newNation);
            onNationAdded();
            onRequestClose();
        } catch (error) {
            console.error('Error adding nation:', error);
        }
    };

    return (
        <Modal isOpen={isOpen} onRequestClose={onRequestClose} contentLabel="Add Nation" className="add-nation-modal" overlayClassName="add-nation-modal-overlay">
            <h2>Add Nation</h2>
            <label>
                Nation Number:
                <input type="number" value={number} onChange={(e) => setName(e.target.value)} />
            </label>
            <button onClick={handleSave}>Save</button>
            <button onClick={onRequestClose}>Cancel</button>
        </Modal>
    );
};

export default AddNationModal;
